<template>
    <slot>
        <div class="mb-1">
            <h3>Paid Amount</h3>
            <vField
                v-model="formData.payment"
                name="amount"
                type="number"
                class="form-control form-control-sm text-right font-20"
                @keyup="validatePaymentAmount"
            />
        </div>
        <div class="mb-1">
            <label class="form-label" for="paymentMode">Mode of Payment</label>
            <v-select
                placeholder="Select Cash & Bank Account"
                class="w-100"
                v-model="formData.mop_account_head_id"
                name="mop_account_head_id"
                :options="cashAndBank"
                label="name"
                :reduce="name => name.id"
            />
        </div>
    </slot>
</template>

<script setup>
import {computed, inject, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import handleReceipt from "@/services/modules/receipt";

const $router = useRoute();
const {fetchCashAndBank} = handleReceipt();
const formData = inject('formData')
const props = defineProps({
    grandTotal: {
        type: Number
    }
})

const companyId = $router.params.companyId;
const cashAndBank = ref([])

const setInitialValue = (array, field) => {
    if(!array.length) return;
    formData.value[field] = array[0].id
}

const validatePaymentAmount = (event) => {
    const amount = event.target.value
    if (amount < 0) {
        showError("Payment Amount cannot be less than 0")
    }
}

onMounted(async () => {
    await Promise.all([
        fetchCashAndBank(companyId).then(res => {
            if (res.data) cashAndBank.value = res.data
        })
    ]).then(() => {
        setInitialValue(cashAndBank.value, 'mop_account_head_id');
    })
    .catch(e => {})
})
</script>

<style scoped>
.font-20 {
    font-size: 20px;
}
</style>